import { ContentMetadataText } from '@quebon/shared-learning/components/common/ContentMetadataText'
import { formatQuizValidationIssues, stepLabelOf, type InvalidQuizEntry } from './validateSampleVars'

/** The same warning entries used by the full book preview's print validation. */
export function InvalidQuizList({ quizzes }: { quizzes: InvalidQuizEntry[] }) {
  return (
    <ul className="text-xs">
      {quizzes.map(quiz => (
        <li key={quiz.quizId} className="px-2 py-1.5 hover:bg-slate-50 rounded">
          <div className="font-medium text-slate-800">
            [<ContentMetadataText text={quiz.lessonName} />] Step{stepLabelOf(quiz.stepIdx)} – Q{quiz.quizNumberInLesson}
          </div>
          <div className="text-red-500">누락: {formatQuizValidationIssues(quiz.issues)}</div>
          <div className="text-slate-400 font-mono">quizId: {quiz.quizId}</div>
        </li>
      ))}
    </ul>
  )
}
